import HttpService from './HttpService';

const API_URL = '/users';

const ProfileService = {
  /**
   * Fetches the current user's profile information
   * @returns {Promise<Object>} Profile data with user info
   */
  getProfile: async () => {
    try {
      const response = await HttpService.get(`${API_URL}/profile`);
      return response.data;
    } catch (error) {
      console.error('Error fetching profile:', error);
      throw error;
    }
  },

  /**
   * Updates the user's profile information
   * @param {Object} profileData - The updated profile data (e.g., first_name, last_name)
   * @returns {Promise<Object>} The updated profile data
   */
  updateProfile: async (profileData) => {
    const { first_name, last_name, scope_reads_to_primary_house } = profileData;
    const allowedData = {};
    if (first_name !== undefined) allowedData.first_name = first_name;
    if (last_name !== undefined) allowedData.last_name = last_name;
    if (scope_reads_to_primary_house !== undefined) {
      allowedData.scope_reads_to_primary_house = scope_reads_to_primary_house;
    }
    try {
      const response = await HttpService.put(`${API_URL}/profile`, allowedData);
      return response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  }
};

export default ProfileService;
